import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {TreeComponent} from '../../../components/v2/tree/tree.component';
import {SaleTaskService} from '@service/crm/sale-task.service';
import {TaskDetailComponent} from '../task-detail/task-detail.component';
import {DashboardCrmService} from '@service/dashboard-crm/dashboard-crm.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'app-tasks',
    templateUrl: './tasks.component.html',
    styleUrls: ['tasks.component.scss'],
    animations: [
        trigger('slideToggle', [
            state('hidden', style({
                height: '0px',
                opacity: 0,
                overflow: 'hidden'
            })),
            state('visible', style({
                height: '*',
                opacity: 1
            })),
            transition('hidden <=> visible', [
                animate('300ms ease-in-out')
            ])
        ])
    ],
    standalone: false
})
export class TasksComponent implements OnInit, OnDestroy {
  @ViewChild(TreeComponent) tree: TreeComponent | undefined;
  @Input() customerId: number | undefined;
  @Input() customerRedirect = true;
  private readonly localStorageFilterExpKey = 'filterMenuExpanded';
  public searchForm: UntypedFormGroup;
  public matTabIndex = 0;
  public hideColumns = ['id', 'leadId', 'customerId', 'note', 'color', 'typeIcon', 'completionDate', 'state'];
  public tasks = undefined;
  public selectionTasks: any = [];
  public actions = {
    tasks: [
      // {
        // icon: 'fa-eye',
        // func: (id: number) => this.openRowDetail(id)
      // }
    ],
  };
  public widgetOptions = {
    daysLeft: 'daysLeft',
    expirationDate: 'date',
    completionDate: 'date',
    efficiency: 'efficiency'
  };
  private destroy$ = new Subject<void>();
  filterExpanded = true;
  canLoadAnimation = false;

  constructor(
    private fb: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private saleTaskService: SaleTaskService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private dashboardService: DashboardCrmService,
    private dialog: MatDialog
  ) {
    this.dashboardService.title = 'CRM - Sales Tasks';
    this.filterExpanded = localStorage.getItem(this.localStorageFilterExpKey) !== '0';
    this.searchForm = this.fb.group({
      expirationDate: this.fb.group({
        type: ['date'],
        from: [],
        to: []
      }),
      completionDate: this.fb.group({
        type: ['date'],
        from: [],
        to: []
      }),
      type: [],
      customer: [],
      seller: [],
      summary: []
    });
    this.activateTabViaPathParam();
  }

  private activateTabViaPathParam(): void {
    this.activatedRoute.data.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.matTabIndex = data.matTabIndex;
      if (this.matTabIndex === 0) {
        this.hideColumns.push('seller');
      } else {
        this.hideColumns = this.hideColumns.filter((x) => x !== 'seller');
      }
    });
  }

  openRowDetail(row: any, customerRedirect?: boolean): void {
    const taskDialog = this.dialog.open(TaskDetailComponent, {
      width: '90%',
      height: 'auto',
      panelClass: ['p-0', 'overflow-auto'],
      disableClose: true,
      id: 'taskDetail'
    });
    taskDialog.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((r) => {
      if (r?.modified) {
        this.updateData();
      }
    });
    taskDialog.componentInstance.id = row.id;
    taskDialog.componentInstance.customerClickable = !this.customerRedirect;
  }

  ngOnInit(): void {
    if (this.customerId) {
      this.matTabIndex = 10;
    }
    this.updateData();
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  updateUrl(index: number): void {
    const links = ['my-task', 'assigned', 'completed'].map((x) => '/crm/tasks/' + x);
    this.router.navigateByUrl(links[index]);
  }

  doSearch(): void {
    const data = this.searchForm.getRawValue();
    this.tree?.applyFilter(data);
  }

  clearFilter(): void {
    this.tree?.clearFilter();
    this.searchForm.reset({
      expirationDate: {type: 'date'},
      completionDate: {type: 'date'}
    });
  }

  updateData(): void {
    let stream$;
    switch (this.matTabIndex) {
      default:
      case 0:
        stream$ = this.saleTaskService.getMyTasks();
        break;
      case 1:
        stream$ = this.saleTaskService.getAssignedTasks();
        break;
      case 2:
        stream$ = this.saleTaskService.getCompletedTasks();
        break;
      case 10:
        stream$ = this.saleTaskService.getAllCustomerTasks(this.customerId || 0);
        break;
    }
    stream$.pipe(takeUntil(this.destroy$)).subscribe((tasks) => {
      this.tasks = tasks;
      this.selectionTasks = this.prepareSelection('type', this.tasks);
      this.cd.detectChanges();
    });
  }

  prepareSelection(key: string, from: any): { name: string; value: string; disabled?: boolean | undefined; }[] {
    return [...new Set([''].concat(from?.map((x: any) => x[key])))].sort().map((z) => ({
      name: z,
      value: z
    }));
  }

  toggleFilters(): void {
    this.canLoadAnimation = true;
    this.filterExpanded = !this.filterExpanded;
    localStorage.setItem(this.localStorageFilterExpKey, String(+this.filterExpanded));
  }

}
